module.exports = __webpack_public_path__ + "static/media/043-chef.b95866ac.svg";